export const getSeatByPosition = (seatLayout, position) => {
    const area = seatLayout.areas.find(a => a.number === position.areaNumber);
    if (!area) {
        return undefined;
    }
    const row = area.rows.find(r => r.number === position.rowNumber);
    if (!row) {
        return undefined;
    }
    return row.seats.find(s => s.position.columnNumber === position.columnNumber);
};
//# sourceMappingURL=get-seat-by-position.js.map